import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {createUser} from "../../store/user-slice";
import {userSchema} from "../../schema/userSchema";
import {getFormData} from "../../models/userModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";

const UserAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {createStatus, error} = useSelector(state => state.user);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(".."); // Adjust the navigation path as needed
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        dispatch(createUser(data));
    };

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const schema = userSchema(); // Define this schema in your schema directory
    const initialData = getFormData(); // Define how initial data is fetched or structured


    return (
        <>
            <SubHeader title="Add User">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserAdd;
